import React from 'react';
import { Button } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import styled from 'styled-components';
import { useGeneralLedger } from './contexts';

type LedgerNavigationLinkProps = {
  // The index in the generalLedgerListItemData array
  index: number;
  // Any other props that styled-components might need
  isCurrent?: boolean;
  children?: React.ReactNode;
};

const StyledButton = styled(Button)`
  color: ${colors.ash};
  justify-content: left;
  line-height: 20px;
  padding: 0 24px;
  text-transform: none;
  width: 100%;

  ${({ isCurrent }) =>
    isCurrent &&
    `
      color: ${colors.charcoal};
      font-weight: 600;
      background-color: #f0f8f8
    `};
`;

const LedgerNavigationLink: React.FC<LedgerNavigationLinkProps> = ({ index, ...props }) => {
  const { scrollToItem } = useGeneralLedger();

  return (
    <StyledButton
      data-heap-id="general-ledger-ledger-navigation-link"
      styleType="total-ghost"
      size="large"
      onClick={() => scrollToItem?.(index)}
      {...props}
    />
  );
};

export default React.memo(LedgerNavigationLink);
